import { ChevronLeftIcon } from '~components/icons'
import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import ListItem from '@mui/material/ListItem'
import { NavLink } from 'react-router-dom'
import { COLORS } from '~theme/colors'
import { LeftNavigationVariant, useNavigation } from '../../navigation-context'

interface ConstructColorsParams {
  isActive: boolean
  variant: LeftNavigationVariant
}

function getDefaultColor({ isActive, variant }: ConstructColorsParams) {
  if (variant === 'primary') {
    return isActive ? COLORS.primary.white : COLORS.secondary.darkBlue
  }
  return isActive ? COLORS.primary.maerskBlue : COLORS.primary.white
}

function getHoverColor({ isActive, variant }: ConstructColorsParams) {
  if (variant === 'primary') {
    return isActive ? COLORS.secondary.lightBlue : COLORS.secondary.darkBlue
  }
  return isActive ? COLORS.primary.maerskBlue : COLORS.secondary.darkBlue
}

function getHoverBackgroundColor({ isActive, variant }: ConstructColorsParams) {
  if (variant === 'primary') {
    return isActive ? COLORS.secondary.darkBlue : COLORS.secondary.blueTint
  }
  return COLORS.primary.white
}

export function MenuItem({
  link,
  label,
  isBackButton = false,
}: {
  link: string
  label: string
  isBackButton?: boolean
}) {
  const { navigationVariant: variant } = useNavigation()

  const getStyle = (isActive: boolean) => {
    if (isBackButton) {
      isActive = false
    }

    return {
      mx: 2,
      minHeight: '40px',
      borderRadius: 1,
      width: 'auto',
      color: getDefaultColor({ isActive, variant }),
      textDecoration: 'none',
      backgroundColor: isActive ? COLORS.secondary.darkBlue : 'transparent',
      '&:hover': {
        color: getHoverColor({ isActive, variant }),
        backgroundColor: getHoverBackgroundColor({ isActive, variant }),
      },
      '& span': { pl: isBackButton ? 3 : 5 },
    }
  }

  return (
    <Box sx={{ '& a': { textDecoration: 'none' } }}>
      <NavLink to={link}>
        {({ isActive }) => {
          return (
            <ListItem sx={getStyle(isActive)}>
              {isBackButton && (
                <ChevronLeftIcon style={{ marginLeft: '-12px' }} />
              )}
              <Typography
                variant="menu"
                sx={{
                  mr: 3,
                  color: 'inherit',
                  whiteSpace: 'normal',
                }}
              >
                {label}
              </Typography>
            </ListItem>
          )
        }}
      </NavLink>
    </Box>
  )
}
